import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const isAuthenticated = !!localStorage.getItem("token"); // Check if token exists
  const userLoggedInDetails = JSON.parse(localStorage.getItem("userLoggedInDetails"));

  // Extract the roles (assuming it's an array)
  const userRoles = userLoggedInDetails?.staffRoles?.map(role => role.permissionName) || [];

  // console.log("🚀 ~ PrivateRoute ~ userRoles:", userRoles);

  // List of restricted roles
  const restrictedRoles = [
    "Support Worker",
    "Senior Support Worker",
    "Support Worker (Office)",
    "Teaching Assistant"
  ];

  // Check if all roles are restricted (i.e., no allowed role exists)
  const hasOnlyRestrictedRoles = userRoles.every(role => restrictedRoles.includes(role));

  if (hasOnlyRestrictedRoles) {
    return <Navigate to="/restricted-web-access" />;
  }

  return isAuthenticated ? element : <Navigate to="/" />;
};

export default PrivateRoute;
